<template>
    <div>
        <div style="padding: 0 20px">
            <!--    新增角色按钮-->
            <div class="top" style="justify-content: space-between">
                <div>
                    <el-select v-model="query.medicineStatus" size="small" style="width: 120px;margin-right: 20px">
                        <el-option key="0" label="已上架" value="0"></el-option>
                        <el-option key="1" label="已下架" value="1"></el-option>
                    </el-select>
                    <el-radio-group v-model="query.medicinalAgentType" size="small">
                        <el-radio-button label="0">全部</el-radio-button>
                        <el-radio-button label="ZYKL">中药颗粒</el-radio-button>
                        <el-radio-button label="ZYYP">中药饮片</el-radio-button>
                        <el-radio-button label="CY">中成药/西药</el-radio-button>
<!--                        <el-radio-button v-for="item in medicinesDosage" :key="item.subentry" :label="item.subentry">{{item.dictPrompt}}</el-radio-button>-->
                    </el-radio-group>

                    <el-input v-model="query.medicinalNameAll"
                              size="small"
                              placeholder="请输入关键字搜索"
                              suffix-icon="el-icon-search"
                              style="width: 260px;margin-left: 20px">
                    </el-input>
                    <el-select v-if="query.medicinalAgentType === 'CY'" v-model="query.medicinalOfficesType" size="small" style="width: 160px;margin-left: 20px">
                        <el-option key="0" label="全部类别" value="0"></el-option>
                        <el-option key="1" label="中医内科" value="1"></el-option>
                        <el-option key="2" label="中医儿科" value="2"></el-option>
                    </el-select>
                </div>
                <div>
                    <el-dropdown style="margin-right: 10px;">
                        <el-button size="small" style="width: 116px">
                            下载模板<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>中药颗粒</el-dropdown-item>
                            <el-dropdown-item>中药饮片</el-dropdown-item>
                            <el-dropdown-item>中成药/西药</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button size="small" style="width: 96px">批量导入</el-button>
                    <el-button type="primary" @click="openAdd" style="width: 68px">新增</el-button>
                </div>
            </div>
            <!--    角色信息表格-->
            <div>
                <el-table :data="tableData" v-loading="loading">
                    <el-table-column label="药品剂型">
                        <template slot-scope="scope">
                            <span v-if="scope.row.medicinalAgentType === 'ZYKL'">颗粒</span>
                            <span v-else-if="scope.row.medicinalAgentType === 'ZYYP'">饮片</span>
                            <span v-else>中成药/西药</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="药品名称" prop="medicinalName"></el-table-column>
<!--                    <el-table-column label="所属类别">-->
<!--                        <template slot-scope="scope">-->
<!--                            <span v-if="scope.row.medicinalOfficesType === '1'">呼吸科</span>-->
<!--                            <span v-else>/</span>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                    <el-table-column label="单位" prop="unit">
                        <template slot-scope="scope">
                            <span v-if="scope.row.unit === 'KE'">克</span>
                            <span v-else-if="scope.row.unit === 'DAI'">袋</span>
                            <span v-else>/</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="规格" prop="medicinalSpecification">
                        <template slot-scope="scope">
                            <span v-if="scope.row.medicinalAgentType !== 'ZYKL' && scope.row.medicinalAgentType !== 'ZYYP'">
                                {{scope.row.dosageCount}}
                                <span v-if="scope.row.oneUnit === 'PIAN'">片</span>
                                <span v-else-if="scope.row.oneUnit === 'PING'">瓶</span>
                                <span v-else-if="scope.row.oneUnit === 'DAI'">袋</span>
                                <span v-else-if="scope.row.oneUnit === 'ZHI'">支</span>
                                <span v-else-if="scope.row.oneUnit === 'HE'">盒</span>
                                <span>/</span>
                                <span v-if="scope.row.unit === 'HE'">盒</span>
                                <span v-else-if="scope.row.unit === 'XIANG'">箱</span>
                            </span>
                            <span v-else>/</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="进货价(元)" prop="medicinalCostPrice"></el-table-column>
                    <el-table-column label="零售价(元)" prop="medicinalUnitPrice"></el-table-column>
                    <el-table-column label="厂家" prop="medicinalManufacturers">
                        <template slot-scope="scope">
                            <span v-if="scope.row.medicinalManufacturers === ''">/</span>
                            <span v-if="scope.row.medicinalManufacturers !== ''">{{scope.row.medicinalManufacturers}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.medicineStatus === 0">已上架</span>
                            <span v-else-if="scope.row.medicineStatus === 1">已下架</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="editMedicinal(scope.row)">编辑</el-button>
                            <el-button v-if="scope.row.medicineStatus === 1" type="text" @click="changeStatus(scope.row)">上架</el-button>
                            <el-button v-else-if="scope.row.medicineStatus === 0" type="text" class="delete-button" @click="changeStatus(scope.row)">下架</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="新增" :visible.sync="dialogAddVisible" width="740px" :close-on-click-modal="false">
            <div class="select-box">
                <div class="select" @click="selectType('ZYKL')" :class="{active : medicinalAdd.medicinalAgentType === 'ZYKL'}">中药颗粒</div>
                <div class="select" @click="selectType('ZYYP')" :class="{active : medicinalAdd.medicinalAgentType === 'ZYYP'}">中药饮片</div>
                <div class="select" @click="selectType('CY')" :class="{active : medicinalAdd.medicinalAgentType === 'CY'}">中成药/西药</div>
            </div>
            <el-form :model="medicinalAdd" label-width="100px" size="small" :rules="rule" ref="add" style="margin-top: 20px"
                     v-if="medicinalAdd.medicinalAgentType === 'ZYKL' || medicinalAdd.medicinalAgentType === 'ZYYP'">
                <div class="dialog-set">
                    <el-form-item label="药品名称:" prop="medicinalName">
                        <el-input v-model="medicinalAdd.medicinalName" style="width: 240px"></el-input>
                    </el-form-item>
                    <el-form-item label="通用名:" prop="medicinalUniversalName">
                        <el-input v-model="medicinalAdd.medicinalUniversalName" style="width: 240px"></el-input>
                    </el-form-item>
                </div>
                <div class="dialog-set">
                    <el-form-item label="首字母:" prop="medicinalCoding">
                        <el-input v-model="medicinalAdd.medicinalCoding" style="width: 240px"></el-input>
                    </el-form-item>
                    <el-form-item label="药品规格:" prop="unit" v-if="medicinalAdd.medicinalAgentType === 'ZYKL'">
                        <el-select v-model="medicinalAdd.unit" size="small" style="width: 115px" placeholder="药品单位">
                            <el-option key="1" label="克" value="KE"></el-option>
                            <el-option key="2" label="袋" value="DAI"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label-width="10px" prop="medicinalSpecification" v-if="medicinalAdd.medicinalAgentType === 'ZYKL' && medicinalAdd.unit === 'DAI'">
                        <el-input v-model="medicinalAdd.medicinalSpecification" style="width: 115px">
                            <span slot="suffix">克/袋</span>
                        </el-input>
                    </el-form-item>
                </div>
                <div class="dialog-set">
                    <el-form-item label="采购单价:" prop="medicinalCostPrice">
                        <el-input v-model="medicinalAdd.medicinalCostPrice" style="width: 240px">
                            <span slot="suffix">元</span>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="零售价格:" prop="medicinalUnitPrice">
                        <el-input v-model="medicinalAdd.medicinalUnitPrice" style="width: 240px">
                            <span slot="suffix">元</span>
                        </el-input>
                    </el-form-item>
                </div>
                <div class="dialog-set">
                    <el-form-item label="库存:" prop="medicinalInventory">
                        <el-input v-model="medicinalAdd.medicinalInventory" style="width: 240px"></el-input>
                    </el-form-item>
                    <el-form-item label="库存下限:" prop="medicinalMinimumQuantity">
                        <el-input v-model="medicinalAdd.medicinalMinimumQuantity" style="width: 240px"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <el-form :model="medicinalAdd" label-width="100px" size="small" :rules="rule" ref="add" style="margin-top: 20px"
                     v-if="medicinalAdd.medicinalAgentType === 'CY'">
                <div class="dialog-set">
                    <el-form-item label="药品名称:" prop="medicinalName">
                        <el-input v-model="medicinalAdd.medicinalName" style="width: 240px"></el-input>
                    </el-form-item>
                    <el-form-item label="首字母:" prop="medicinalCoding">
                        <el-input v-model="medicinalAdd.medicinalCoding" style="width: 240px"></el-input>
                    </el-form-item>
                </div>
                <div class="dialog-set">
                    <el-form-item label="所属类别:" prop="medicinalType">
                        <el-select v-model="medicinalAdd.medicinalType" style="width: 240px" placeholder="产品类别" @change="selectProductType">
                            <el-option v-for="item in typeList" :key="item.typeId" :label="item.typeName" :value="item.typeId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="次级分类:" prop="medicinalOfficesType">
                        <el-select v-model="medicinalAdd.medicinalOfficesType" style="width: 240px" placeholder="次级分类">
                            <el-option v-for="item in typeDetailList" :key="item.typeDetailId" :label="item.typeDetailName" :value="item.typeDetailId"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="dialog-set">
                    <el-form-item label="药品条形码:" prop="medicinalBarCode">
                        <el-input v-model="medicinalAdd.medicinalBarCode" style="width: 240px"></el-input>
                        <!--                        <div style="width: 240px;height: 32px;border-radius: 6px">-->
                        <!--                            <img :src="medicinalAdd.medicinalBarCode" style="width: 240px;height: 32px;position: absolute;top: 0;border-radius: 6px">-->
                        <!--                            <input type="file" accept="image/*" @change="uploadImg"-->
                        <!--                                   style="width: 240px;height: 32px;position: absolute;top: 0;border-radius: 6px;opacity: 0" ref="picture"/>-->
                        <!--                        </div>-->
                    </el-form-item>
                    <el-form-item label="生产厂家:" prop="medicinalManufacturers">
                        <el-input v-model="medicinalAdd.medicinalManufacturers" style="width: 240px"></el-input>
                    </el-form-item>
                </div>
                <div class="dialog-set">
                    <el-form-item label="批注文号:" prop="medicinalReferenceNumber">
                        <el-input v-model="medicinalAdd.medicinalReferenceNumber" style="width: 240px"></el-input>
                    </el-form-item>
                    <el-form-item label="供应商:" prop="medicinalSupplier">
                        <el-input v-model="medicinalAdd.medicinalSupplier" style="width: 240px"></el-input>
                    </el-form-item>
                </div>
                <div class="dialog-set">
                    <el-form-item label="产品规格:" prop="dosageCount">
                        <el-input v-model="medicinalAdd.dosageCount" style="width: 105px" placeholder="制剂数量"></el-input>
                    </el-form-item>
                    <el-form-item prop="oneUnit" label-width="10px">
                        <el-select v-model="medicinalAdd.oneUnit" style="width: 105px" placeholder="制剂单位" @change="selectOneUnit">
                            <el-option v-for="item in oneUnitList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <div style="margin: 5px 10px;font-size: 22px;color:rgba(153,153,153,1);"><span>/</span></div>
                    <el-form-item prop="unit" label-width="0">
                        <el-select v-model="medicinalAdd.unit" style="width: 105px" placeholder="包装单位">
                            <el-option key="1" label="盒" value="HE"></el-option>
                            <el-option key="2" label="箱" value="XIANG"></el-option>
                        </el-select>
                    </el-form-item>
                    <div style="margin: 7px 10px;font-size: 14px;color:rgba(153,153,153,1);"><span>例如“12片/盒”</span></div>
                </div>
                <div class="dialog-set">
                    <el-form-item label="用法:" prop="dosageUsage">
                        <el-select v-model="medicinalAdd.dosageUsage" style="width: 105px" placeholder="用法">
                            <el-option key="1" label="口服" value="1"></el-option>
                            <el-option key="2" label="冲服" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="频次:" prop="medicinalFrequency">
                        <el-select v-model="medicinalAdd.medicinalFrequency" style="width: 105px" placeholder="频次">
                            <el-option key="1" label="一日一次" value="1"></el-option>
                            <el-option key="2" label="一日两次" value="2"></el-option>
                            <el-option key="3" label="一日三次" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="单次剂量:" prop="dosage">
                        <el-input v-model="medicinalAdd.dosage" style="width: 105px"></el-input>
                        <span>{{oneUnit}}</span>
                    </el-form-item>
                </div>
                <div class="dialog-set">
                    <el-form-item label="采购单价:">
                        <el-input v-model="medicinalAdd.medicinalCostPrice" style="width: 240px">
                            <span slot="suffix">元</span>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="零售价格:" prop="medicinalUnitPrice">
                        <el-input v-model="medicinalAdd.medicinalUnitPrice" style="width: 240px">
                            <span slot="suffix">元</span>
                        </el-input>
                    </el-form-item>
                </div>
                <div class="dialog-set">
                    <el-form-item label="库存:" prop="medicinalInventory">
                        <el-input v-model="medicinalAdd.medicinalInventory" style="width: 240px"></el-input>
                    </el-form-item>
                    <el-form-item label="库存下限:" prop="medicinalMinimumQuantity">
                        <el-input v-model="medicinalAdd.medicinalMinimumQuantity" style="width: 240px"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogAddVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmAdd">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="编辑药材" :visible.sync="dialogEditVisible" width="740px" :close-on-click-modal="false">
            <div class="select-box">
                <div class="select" @click="editSelectType('ZYKL')" :class="{active : medicinalEdit.medicinalAgentType === 'ZYKL'}">中药颗粒</div>
                <div class="select" @click="editSelectType('ZYYP')" :class="{active : medicinalEdit.medicinalAgentType === 'ZYYP'}">中药饮片</div>
                <div class="select" @click="editSelectType('CY')" :class="{active : medicinalEdit.medicinalAgentType === 'CY'}">中成药/西药</div>
            </div>
            <el-form :model="medicinalEdit" label-width="100px" size="small" :rules="rule" ref="add" style="margin-top: 20px"
                     v-if="medicinalEdit.medicinalAgentType === 'ZYKL' || medicinalEdit.medicinalAgentType === 'ZYYP'">
                <div class="dialog-set">
                    <el-form-item label="药品名称:" prop="medicinalName">
                        <el-input v-model="medicinalEdit.medicinalName" style="width: 240px"></el-input>
                    </el-form-item>
                    <el-form-item label="通用名:">
                        <el-input v-model="medicinalEdit.medicinalUniversalName" style="width: 240px"></el-input>
                    </el-form-item>
                </div>
                <div class="dialog-set">
                    <el-form-item label="首字母" prop="medicinalCoding">
                        <el-input v-model="medicinalEdit.medicinalCoding" style="width: 240px"></el-input>
                    </el-form-item>
                    <el-form-item label="药品规格" prop="unit" v-if="medicinalEdit.medicinalAgentType === 'ZYKL'">
                        <el-select v-model="medicinalEdit.unit" size="small" style="width: 115px" placeholder="药品单位">
                            <el-option key="1" label="克" value="KE"></el-option>
                            <el-option key="2" label="袋" value="DAI"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label-width="10px" prop="age" v-if="medicinalEdit.medicinalAgentType === 'ZYKL' && medicinalEdit.unit === 'DAI'">
                        <el-input v-model="medicinalEdit.medicinalSpecification" style="width: 115px">
                            <span slot="suffix">克/袋</span>
                        </el-input>
                    </el-form-item>
                </div>
                <div class="dialog-set">
                    <el-form-item label="采购单价">
                        <el-input v-model="medicinalEdit.medicinalCostPrice" style="width: 240px">
                            <span slot="suffix">元</span>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="零售价格" prop="medicinalUnitPrice">
                        <el-input v-model="medicinalEdit.medicinalUnitPrice" style="width: 240px">
                            <span slot="suffix">元</span>
                        </el-input>
                    </el-form-item>
                </div>
                <div class="dialog-set">
                    <el-form-item label="库存">
                        <el-input v-model="medicinalEdit.medicinalInventory" style="width: 240px"></el-input>
                    </el-form-item>
                    <el-form-item label="库存下限">
                        <el-input v-model="medicinalEdit.medicinalMinimumQuantity" style="width: 240px"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <el-form :model="medicinalEdit" label-width="100px" size="small" :rules="rule" ref="add" style="margin-top: 20px"
                     v-if="medicinalEdit.medicinalAgentType === 'CY'">
                <div class="dialog-set">
                    <el-form-item label="药品名称:" prop="medicinalName">
                        <el-input v-model="medicinalEdit.medicinalName" style="width: 240px"></el-input>
                    </el-form-item>
                    <el-form-item label="首字母:" prop="medicinalCoding">
                        <el-input v-model="medicinalEdit.medicinalCoding" style="width: 240px"></el-input>
                    </el-form-item>
                </div>
                <div class="dialog-set">
                    <el-form-item label="所属类别:" prop="medicinalType">
                        <el-select v-model="medicinalEdit.medicinalType" style="width: 240px" placeholder="产品类别" @change="selectProductType">
                            <el-option v-for="item in typeList" :key="item.typeId" :label="item.typeName" :value="item.typeId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="次级分类:" prop="medicinalOfficesType">
                        <el-select v-model="medicinalEdit.medicinalOfficesType" style="width: 240px" placeholder="次级分类">
                            <el-option v-for="item in typeDetailList" :key="item.typeDetailId" :label="item.typeDetailName" :value="item.typeDetailId"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="dialog-set">
                    <el-form-item label="药品条形码:" prop="age">
                        <el-input v-model="medicinalEdit.medicinalBarCode" style="width: 240px"></el-input>
                        <!--                        <div style="width: 240px;height: 32px;border-radius: 6px">-->
                        <!--                            <img :src="medicinalAdd.medicinalBarCode" style="width: 240px;height: 32px;position: absolute;top: 0;border-radius: 6px">-->
                        <!--                            <input type="file" accept="image/*" @change="uploadImg"-->
                        <!--                                   style="width: 240px;height: 32px;position: absolute;top: 0;border-radius: 6px;opacity: 0" ref="picture"/>-->
                        <!--                        </div>-->
                    </el-form-item>
                    <el-form-item label="生产厂家:" prop="medicinalManufacturers">
                        <el-input v-model="medicinalEdit.medicinalManufacturers" style="width: 240px"></el-input>
                    </el-form-item>
                </div>
                <div class="dialog-set">
                    <el-form-item label="批注文号:" prop="patientName">
                        <el-input v-model="medicinalEdit.medicinalReferenceNumber" style="width: 240px"></el-input>
                    </el-form-item>
                    <el-form-item label="供应商:" prop="medicinalSupplier">
                        <el-input v-model="medicinalEdit.medicinalSupplier" style="width: 240px"></el-input>
                    </el-form-item>
                </div>
                <div class="dialog-set">
                    <el-form-item label="产品规格:" prop="dosageCount">
                        <el-input v-model="medicinalEdit.dosageCount" style="width: 105px" placeholder="制剂数量"></el-input>
                    </el-form-item>
                    <el-form-item prop="oneUnit:" label-width="10px">
                        <el-select v-model="medicinalEdit.oneUnit" style="width: 105px" placeholder="制剂单位" @change="editSelectProductType">
                            <el-option v-for="item in oneUnitList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <div style="margin: 5px 10px;font-size: 22px;color:rgba(153,153,153,1);"><span>/</span></div>
                    <el-form-item prop="unit" label-width="0">
                        <el-select v-model="medicinalEdit.unit" style="width: 105px" placeholder="包装单位">
                            <el-option key="1" label="盒" value="HE"></el-option>
                            <el-option key="2" label="箱" value="XIANG"></el-option>
                        </el-select>
                    </el-form-item>
                    <div style="margin: 7px 10px;font-size: 14px;color:rgba(153,153,153,1);"><span>例如“12片/盒”</span></div>
                </div>
                <div class="dialog-set">
                    <el-form-item label="用法:" prop="dosageUsage">
                        <el-select v-model="medicinalEdit.dosageUsage" style="width: 105px" placeholder="用法">
                            <el-option key="1" label="口服" value="1"></el-option>
                            <el-option key="2" label="冲服" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="频次:" prop="medicinalFrequency">
                        <el-select v-model="medicinalEdit.medicinalFrequency" style="width: 105px" placeholder="频次">
                            <el-option key="1" label="一日一次" value="1"></el-option>
                            <el-option key="2" label="一日两次" value="2"></el-option>
                            <el-option key="3" label="一日三次" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="单次剂量:" prop="dosage">
                        <el-input v-model="medicinalEdit.dosage" style="width: 105px"></el-input>
                        <span>{{editOneUnit}}</span>
                    </el-form-item>
                </div>
                <div class="dialog-set">
                    <el-form-item label="采购单价:">
                        <el-input v-model="medicinalEdit.medicinalCostPrice" style="width: 240px">
                            <span slot="suffix">元</span>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="零售价格:" prop="medicinalUnitPrice">
                        <el-input v-model="medicinalEdit.medicinalUnitPrice" style="width: 240px">
                            <span slot="suffix">元</span>
                        </el-input>
                    </el-form-item>
                </div>
                <div class="dialog-set">
                    <el-form-item label="库存:">
                        <el-input v-model="medicinalEdit.medicinalInventory" style="width: 240px"></el-input>
                    </el-form-item>
                    <el-form-item label="库存下限:">
                        <el-input v-model="medicinalEdit.medicinalMinimumQuantity" style="width: 240px"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogEditVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmEdit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script type="text/javascript">
    export default {
        data() {
            return {
                // token
                authorization:localStorage.getItem('authorization'),
                // 搜索数据
                query: {
                    medicineStatus: '0',
                    medicinalNameAll: '',
                    medicinalAgentType: '',
                    medicinalOfficesType: '',
                },
                // 表格页
                pageNum: 1,
                pageSize: 10,
                total: 0,
                // loading
                loading: true,
                // 列表数据
                tableData: [],
                // medicinesDosage: [],
                // 产品类别
                typeList: [],
                // 次级分类
                typeDetailList: [],
                oneUnitList: [
                    {
                        value: 'PIAN',
                        label: '片',
                    },
                    {
                        value: 'PING',
                        label: '瓶',
                    },
                    {
                        value: 'DAI',
                        label: '袋',
                    },
                    {
                        value: 'ZHI',
                        label: '支',
                    },
                    {
                        value: 'HE',
                        label: '盒',
                    }
                ],
                // 剂量后缀
                oneUnit: '',
                editOneUnit: '',
                // 新增弹窗
                dialogAddVisible: false,
                // 表单验证
                rule:{
                    medicinalName:[{required: true, message: '请输入药品名称', trigger: 'blur'}],
                    medicinalCoding: [{required: true, message: '请输入药品首字母', trigger: 'blur'}],
                    unit: [{required: true, message: '请选择药品单位', trigger: 'change'}],
                    medicinalType: [{required: true, message: '请选择产品类别', trigger: 'change'}],
                    medicinalOfficesType: [{required: true, message: '请选择次级分类', trigger: 'change'}],
                    medicinalManufacturers: [{required: true, message: '请输入药品名称', trigger: 'blur'}],
                    medicinalUnitPrice: [{required: true, message: '请输入药品零售价', trigger: 'blur'}],
                    medicinalSupplier: [{required: true, message: '请输入供应商名称', trigger: 'blur'}],
                    dosageUsage:[{required: true, message: '请选择用法', trigger: 'change'}],
                    medicinalFrequency:[{required: true, message: '请选择频次', trigger: 'change'}],
                    dosage:[{required: true, message: '请输入剂量', trigger: 'blur'}],
                    oneUnit: [{required: true, message: '请选择制剂单位', trigger: 'change'}],
                    dosageCount: [{required: true, message: '请输入制剂数量', trigger: 'blur'}],
                },
                medicinalAdd: {
                    // 药品剂型 颗粒饮片1
                    medicinalAgentType: 'ZYKL',
                    // 药品名称1
                    medicinalName: '',
                    // 药品通用名1
                    medicinalUniversalName: '',
                    // 药品简码1
                    medicinalCoding: '',
                    // 单位1
                    unit: '',
                    medicinalSpecification: '',
                    medicinalType: '',
                    // 药品次级类别
                    medicinalOfficesType: '',
                    // 药品条形码
                    medicinalBarCode: '',
                    // 药品批注文号
                    medicinalReferenceNumber: '',
                    // 药品厂家
                    medicinalManufacturers: '',
                    // 药品供应商1
                    medicinalSupplier: '',
                    // 制剂单位
                    oneUnit: '',
                    //制剂数量
                    dosageCount: '',
                    // 用法
                    dosageUsage: '',
                    // 频率
                    medicinalFrequency: '',
                    // 剂量
                    dosage: '',
                    // 药品进价
                    medicinalCostPrice: '',
                    // 零售价
                    medicinalUnitPrice: '',
                    // 药品库存
                    medicinalInventory: '',
                    // 药品库存下限
                    medicinalMinimumQuantity: '',
                },
                dialogEditVisible: false,
                medicinalEdit: {
                    medicinalName: '',
                    medicinalUniversalName: '',
                    medicinalCoding: '',
                    medicinalAgentType: '1',
                    medicinalReferenceNumber: '',
                    medicinalOfficesType: '',
                    medicinalManufacturers: '',
                    medicinalBarCode: '',
                    medicinalMinimumQuantity: '',
                    medicinalSupplier: '',
                    medicinalSpecification: '',
                    medicinalTopUnit: '',
                    medicinalInventory: '',
                    medicinalCostPrice: '',
                    medicinalUnitPrice: '',
                    medicinalFrequency: '',
                    medicinalOneDosage: '',
                    medicinalTreatmentCycle: '',
                    medicinalProducedData: '',
                    medicinalExpirationDate: '',
                }
            }
        },
        methods: {
            // 获取列表数据
            getData() {
                this.loading = true
                let params = {
                    medicineStatus: this.query.medicineStatus,
                    medicinalNameAll: this.query.medicinalNameAll,
                    medicinalAgentType: this.query.medicinalAgentType,
                    medicinalOfficesType: '',
                }
                if (this.query.medicinalAgentType === '0') {
                    params.medicinalAgentType = ''
                } else if (this.query.medicinalAgentType === 'CY') {
                    params.medicinalOfficesType = this.query.medicinalOfficesType
                }
                this.axios.post('/api-b/10031/100084/' + this.pageNum + '/' + this.pageSize,params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list.length !== 0) {
                            this.tableData = res.data.data.list
                            this.total = res.data.data.total
                        } else {
                            this.$message.info('暂无药材')
                            this.tableData = []
                        }
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                    }
                    this.loading = false
                }).catch(error => {
                    this.tableData = []
                    this.loading = false
                })
            },
            // 换页
            handlePageChange(val) {
                this.pageNum = val
                this.getData()
            },
            // 打开新增
            openAdd() {
                this.dialogAddVisible = true
                this.$nextTick(() => {
                    this.$refs.add.resetFields()
                })
            },
            // 选择剂型
            selectType(data) {
                this.medicinalAdd.medicinalAgentType = data
                if (this.typeList.length === 0 && data === 'CY') {
                    this.getProductType()
                }
                this.$nextTick(() => {
                    this.$refs.add.clearValidate()
                })
            },
            // 获取产品类别
            getProductType() {
                let params = {
                    pageNum: 1,
                    pageSize: 999,
                }
                this.axios.post('/api-b/10038/100141',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list !== null) {
                            this.typeList = res.data.data.list
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                }).catch(() => {})
            },
            // 选择产品类别
            selectProductType(val) {
                let params = new FormData()
                params.append('typeId',val)
                this.axios.post('/api-b/10039/100149',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.typeDetailList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 选择制剂单位
            selectOneUnit(val) {
                this.oneUnit = this.oneUnitList.find(item => {
                    return item.value === val
                }).label
            },
            // 上传图片
            // uploadImg() {
            //     let inputDOM = this.$refs.picture;
            //     let file = inputDOM.files[0];
            //     let params = new FormData()
            //     params.append('file',file)
            //     this.axios.post('/api-f/10027/100065',params,{
            //         headers:{
            //             Authorization: this.authorization,
            //             'Content-Type':'multipart/form-data'
            //         }
            //     }).then(res => {
            //         if (res.data.code === 10000) {
            //             this.$message.success(res.data.message)
            //             this.medicinalAdd.medicinalBarCode = res.data.data.fileUrl
            //         } else {
            //             this.$message.error(res.data.message)
            //         }
            //     })
            // },
            // 确认新增
            confirmAdd() {
                this.$refs.add.validate(valid => {
                    if (valid) {
                        let params = {}
                        if (this.medicinalAdd.medicinalAgentType === 'ZYKL') {
                            params = {
                                medicinalAgentType: 'ZYKL',
                                medicinalName: this.medicinalAdd.medicinalName,
                                medicinalUniversalName: this.medicinalAdd.medicinalUniversalName,
                                medicinalCoding: this.medicinalAdd.medicinalCoding,
                                unit: this.medicinalAdd.unit,
                                medicinalCostPrice: this.medicinalAdd.medicinalCostPrice,
                                medicinalUnitPrice: this.medicinalAdd.medicinalUnitPrice,
                                medicinalInventory: this.medicinalAdd.medicinalInventory,
                                medicinalMinimumQuantity: this.medicinalAdd.medicinalMinimumQuantity,
                            }
                            if (this.medicinalAdd.unit === 'DAI') {
                                params.oneUnit = 'KE'
                                params.medicinalSpecification = this.medicinalAdd.medicinalSpecification
                            }
                        } else if (this.medicinalAdd.medicinalAgentType === 'ZYYP') {
                            params = {
                                medicinalAgentType: 'ZYYP',
                                medicinalName: this.medicinalAdd.medicinalName,
                                medicinalUniversalName: this.medicinalAdd.medicinalUniversalName,
                                medicinalCoding: this.medicinalAdd.medicinalCoding,
                                unit: 'KE',
                                medicinalCostPrice: this.medicinalAdd.medicinalCostPrice,
                                medicinalUnitPrice: this.medicinalAdd.medicinalUnitPrice,
                                medicinalInventory: this.medicinalAdd.medicinalInventory,
                                medicinalMinimumQuantity: this.medicinalAdd.medicinalMinimumQuantity,
                            }
                        } else if (this.medicinalAdd.medicinalAgentType === 'CY'){
                            params = {
                                medicinalAgentType: 'CY',
                                medicinalName: this.medicinalAdd.medicinalName,
                                medicinalUniversalName: this.medicinalAdd.medicinalUniversalName,
                                medicinalCoding: this.medicinalAdd.medicinalCoding,
                                unit: this.medicinalAdd.unit,
                                medicinalOfficesType: this.medicinalAdd.medicinalOfficesType,
                                medicinalBarCode: this.medicinalAdd.medicinalBarCode,
                                medicinalReferenceNumber: this.medicinalAdd.medicinalReferenceNumber,
                                medicinalManufacturers: this.medicinalAdd.medicinalManufacturers,
                                medicinalSupplier: this.medicinalAdd.medicinalSupplier,
                                oneUnit: this.medicinalAdd.oneUnit,
                                dosageCount: this.medicinalAdd.dosageCount,
                                dosageUsage: this.medicinalAdd.dosageUsage,
                                medicinalFrequency: this.medicinalAdd.medicinalFrequency,
                                dosage: this.medicinalAdd.dosage,
                                medicinalCostPrice: this.medicinalAdd.medicinalCostPrice,
                                medicinalUnitPrice: this.medicinalAdd.medicinalUnitPrice,
                                medicinalInventory: this.medicinalAdd.medicinalInventory,
                                medicinalMinimumQuantity: this.medicinalAdd.medicinalMinimumQuantity,
                            }
                        }
                        this.axios.post('/api-b/10031/100085/',params,{
                            headers:{
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.dialogAddVisible = false
                                this.$message.success(res.data.message)
                                this.getData()
                                this.$nextTick(() => {
                                    this.$refs.add.resetFields()
                                })
                            } else  {
                                this.$message.error(res.data.message)
                            }
                        })
                    }
                })
            },
            // 获取药材详情,打开编辑
            editMedicinal(data) {
                let params = new FormData()
                params.append('medicinalId',data.medicinalId)
                this.axios.post('/api-b/10031/100087/',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.medicinalEdit = res.data.data
                        if (this.medicinalEdit.medicinalAgentType !== 'ZYKL' && this.medicinalEdit.medicinalAgentType !== 'ZYYP') {
                            this.medicinalEdit.medicinalType = this.medicinalEdit.medicinalAgentType
                            this.medicinalEdit.medicinalAgentType = 'CY'
                            this.medicinalEdit.dosageUsage = this.medicinalEdit.dosageUsage + ''
                            this.editOneUnit = this.oneUnitList.find(item => {
                                return item.value === this.medicinalEdit.oneUnit
                            }).label
                        }
                        this.dialogEditVisible = true
                        this.getProductType()
                        this.selectProductType(this.medicinalEdit.medicinalType)
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 编辑弹窗切换剂型
            editSelectType(data) {
                this.medicinalEdit.medicinalAgentType = data
                if (this.typeList.length === 0 && data === 'CY') {
                    this.getProductType()
                }
            },
            // 编辑弹窗选择制剂单位
            editSelectProductType(val) {
                this.editOneUnit = this.oneUnitList.find(item => {
                    return item.value === val
                }).label
            },
            // 确认编辑
            confirmEdit() {
                let params = {}
                if (this.medicinalEdit.medicinalAgentType === 'ZYKL') {
                    params = {
                        pharmacyId: this.medicinalEdit.pharmacyId,
                        medicinalId: this.medicinalEdit.medicinalId,
                        medicinalAgentType: 'ZYKL',
                        medicinalName: this.medicinalEdit.medicinalName,
                        medicinalUniversalName: this.medicinalEdit.medicinalUniversalName,
                        medicinalCoding: this.medicinalEdit.medicinalCoding,
                        unit: this.medicinalEdit.unit,
                        medicinalCostPrice: this.medicinalEdit.medicinalCostPrice,
                        medicinalUnitPrice: this.medicinalEdit.medicinalUnitPrice,
                        medicinalInventory: this.medicinalEdit.medicinalInventory,
                        medicinalMinimumQuantity: this.medicinalEdit.medicinalMinimumQuantity,
                    }
                    if (this.medicinalAdd.unit === 'DAI') {
                        params.oneUnit = 'KE'
                        params.medicinalSpecification = this.medicinalEdit.medicinalSpecification
                    }
                } else if (this.medicinalEdit.medicinalAgentType === 'ZYYP') {
                    params = {
                        pharmacyId: this.medicinalEdit.pharmacyId,
                        medicinalId: this.medicinalEdit.medicinalId,
                        medicinalAgentType: 'ZYYP',
                        unit: 'KE',
                        medicinalName: this.medicinalEdit.medicinalName,
                        medicinalUniversalName: this.medicinalEdit.medicinalUniversalName,
                        medicinalCoding: this.medicinalEdit.medicinalCoding,
                        medicinalCostPrice: this.medicinalEdit.medicinalCostPrice,
                        medicinalUnitPrice: this.medicinalEdit.medicinalUnitPrice,
                        medicinalInventory: this.medicinalEdit.medicinalInventory,
                        medicinalMinimumQuantity: this.medicinalEdit.medicinalMinimumQuantity,
                    }
                } else if (this.medicinalEdit.medicinalAgentType === 'CY') {
                    params = {
                        pharmacyId: this.medicinalEdit.pharmacyId,
                        medicinalId: this.medicinalEdit.medicinalId,
                        medicinalAgentType: 'CY',
                        medicinalName: this.medicinalEdit.medicinalName,
                        medicinalUniversalName: this.medicinalEdit.medicinalUniversalName,
                        medicinalCoding: this.medicinalEdit.medicinalCoding,
                        unit: this.medicinalEdit.unit,
                        medicinalOfficesType: this.medicinalEdit.medicinalOfficesType,
                        medicinalBarCode: this.medicinalEdit.medicinalBarCode,
                        medicinalReferenceNumber: this.medicinalEdit.medicinalReferenceNumber,
                        medicinalManufacturers: this.medicinalEdit.medicinalManufacturers,
                        medicinalSupplier: this.medicinalEdit.medicinalSupplier,
                        oneUnit: this.medicinalEdit.oneUnit,
                        dosageCount: this.medicinalEdit.dosageCount,
                        dosageUsage: this.medicinalEdit.dosageUsage,
                        medicinalFrequency: this.medicinalEdit.medicinalFrequency,
                        dosage: this.medicinalEdit.dosage,
                        medicinalCostPrice: this.medicinalEdit.medicinalCostPrice,
                        medicinalUnitPrice: this.medicinalEdit.medicinalUnitPrice,
                        medicinalInventory: this.medicinalEdit.medicinalInventory,
                        medicinalMinimumQuantity: this.medicinalEdit.medicinalMinimumQuantity,
                    }
                }
                this.axios.post('/api-b/10031/100086/',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.dialogEditVisible = false
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 药材上下架
            changeStatus(data){
                let params = {
                    medicinalId: data.medicinalId,
                }
                if (data.medicineStatus === 0) {
                    params.medicineStatus = 1
                } else {
                    params.medicineStatus = 0
                }
                this.axios.post('/api-b/10031/100134',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000){
                        this.$message.success(res.data.message)
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                        this.getData()
                    }
                })
            }
        },
        watch: {
            query: {
                handler() {
                    this.pageNum = 1
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        this.getData();
                    }, 300);
                },
                deep:true
            }
        },
        created() {
            this.getData()
            // this.getDosage()
        }
    }
</script>


<style>
    .el-button--small {
        width: 65px;
        height: 32px;
        font-size: 14px;
    }
    .el-button--primary:hover {
        background:rgba(120,180,255,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
    .el-button--primary:focus {
        background:rgba(57,129,221,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
</style>

<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
    .dialog-set{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }
    .select-box {
        display: flex;
        flex-direction: row;
        height: 36px;
        line-height:36px;
        margin-top: -25px;
        font-size: 14px
    }
    .select {
        padding: 0 15px;
        /*width: 80px;*/
        text-align: center
    }
    .active{
        box-shadow: 0 2px 0 rgba(97,167,255,1);
        color:rgba(97,167,255,1);
    }
</style>